import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'objectFilter',
    pure: false
})
export class PipeObjectFilter implements PipeTransform {
    transform(items: any[], key : any,  value: any, contain: boolean = true, textContain:boolean = false): any {

        if (!items || !value || !items?.length) {
            return [];
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items?.filter(item => {
            /*if(typeof key === 'object' && typeof value === 'object'){
                let has = 0;
                
                value.forEach((v, k) => {
                    console.log(v, key[k], k, item[key[k]]);
                    if(item[key[k]] == v)
                        has++;
                });
                console.log(has);
                return contain? has == value.length : has != value.length;
            }*/

            let i = typeof key === 'object'? item : item[key];
            if(typeof key === 'object')
                key.map(k => {
                    if(typeof i[k] !== 'undefined')
                        i = i[k];
                } );

            let has = (i == value || (typeof value ==='object' && typeof i ==='object' && value.filter(v => i.indexOf(v) > -1)?.length == value?.length) || (typeof value ==='object' && value.indexOf(i) > -1) || (typeof i === 'object' && i.indexOf(value) !== -1) || (typeof i === 'string' && typeof value === 'string' && i?.toLowerCase() == value?.toLowerCase() && !textContain) || (typeof i === 'string' && typeof value === 'string' && i?.toLowerCase().indexOf(value?.toLowerCase()) > -1 && textContain));

            return contain? has : !has;
        });
    }
}